module.exports = __webpack_public_path__ + "img/huiyuan1.8409e99a.jpg";